var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`sc-city-title ${_vm.$mq}`]},[_c('r-icon',{attrs:{"name":_vm.iconName,"size":24}}),_c('r-title',{attrs:{"type":"title-1","color-type":"secondary"}},[_vm._v(" "+_vm._s(_vm.$t(_vm.city))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }